module.exports = __webpack_public_path__ + "img/chatea.4b7f5d89.png";